<div>
  <div *ngIf="button" role="button" >        
    <ng-content></ng-content>
  </div>  
</div>